import getByPath from 'getbypath';
export const errorHandlerUtils = {
	methods: {
		hasFormError(path, error) {
			if (error) {
				return getByPath(this, `$v.${path}.$dirty`) && getByPath(this, `$v.${path}`) && getByPath(this, `$v.${path}.${error}`) == false;
			} else {
				return getByPath(this, `$v.${path}.$dirty`) && getByPath(this, `$v.${path}.$invalid`);
			}
		},
		validateField(...pathList) {
			pathList && pathList.forEach(path => {
				const touchFn = getByPath(this, `$v.${path}.$touch`);
				setTimeout(touchFn, 500);
			});
		}
	}
};
